import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

export default function Smiley() {
  return (
    <Svg fill="none" height="45" viewBox="0 0 46 45" width="46">
      <Path
        d="M23 44.5C35.64 44.5 45.88 34.54 45.88 22.25C45.88 9.96 35.64 0 23 0C10.36 0 0.12 9.96 0.12 22.25C0.12 34.54 10.36 44.5 23 44.5Z"
        fill="#F7E9AB"
      />
      <Path
        d="M44.1 18.44C44.49 18.44 44.92 19.01 45.24 20.16C45.62 21.79 45.68 23.48 45.42 25.13C45.06 27.62 44.23 30.03 42.95 32.21C41.38 34.97 39.19 37.34 36.55 39.15C33.9 40.96 30.87 42.16 27.67 42.67C25.13 43.1 22.52 43.06 19.99 42.55C18.3 42.23 16.68 41.61 15.23 40.7C14.22 40.03 13.81 39.44 13.96 39.09C14.29 38.32 16.73 38.75 20.36 38.57C24.94 38.41 29.39 37.01 33.2 34.52C36.9 31.87 39.75 28.27 41.44 24.13C42.88 20.87 43.25 18.49 44.1 18.44Z"
        fill="#F8CAAA"
      />
      <Path
        d="M24.05 27.63C26.42 27.49 28.67 26.51 30.35 24.88C31.38 23.87 31.97 22.53 32.01 21.11C31.97 20.45 31.7 19.82 31.25 19.33C30.8 18.83 30.2 18.5 29.53 18.38C28.56 18.37 27.61 18.66 26.84 19.23C26.07 19.81 25.2 20.25 24.27 20.54C22.93 20.84 21.56 20.32 20.29 19.82C19.02 19.32 17.66 18.75 16.31 18.99C15.84 19.02 15.4 19.17 15.02 19.43C14.63 19.68 14.33 20.03 14.13 20.44C14.13 20.44 13.44 21.89 14.82 23.83C15.89 25.18 17.31 26.24 18.92 26.9C20.54 27.57 22.3 27.82 24.05 27.63Z"
        fill="white"
      />
      <Path
        d="M13.65 14.98C13.45 14.62 13.15 14.33 12.78 14.14C12.41 13.95 11.98 13.88 11.57 13.92C11.3 13.93 11.04 14.01 10.82 14.16C10.5 14.4 10.25 14.72 10.1 15.09C9.96 15.45 9.91 15.85 9.98 16.24C10.05 16.5 10.16 16.75 10.33 16.96C10.49 17.17 10.7 17.35 10.94 17.48C11.18 17.62 11.45 17.7 11.72 17.73C12 17.75 12.27 17.73 12.53 17.64C12.79 17.54 13.02 17.39 13.22 17.2C13.41 17.02 13.56 16.79 13.67 16.54C13.77 16.29 13.82 16.03 13.82 15.76C13.82 15.49 13.76 15.23 13.65 14.98Z"
        fill="white"
      />
      <Path
        d="M35.44 15.05C35.24 14.69 34.94 14.4 34.57 14.21C34.19 14.02 33.77 13.94 33.36 13.99C33.09 14 32.83 14.08 32.61 14.22C32.29 14.46 32.04 14.78 31.89 15.15C31.74 15.52 31.7 15.92 31.77 16.31C31.83 16.57 31.95 16.82 32.12 17.03C32.28 17.25 32.49 17.42 32.73 17.56C32.97 17.69 33.24 17.77 33.51 17.8C33.78 17.83 34.06 17.8 34.32 17.72C34.58 17.62 34.81 17.47 35 17.28C35.2 17.09 35.35 16.86 35.46 16.61C35.56 16.37 35.61 16.1 35.61 15.83C35.61 15.56 35.55 15.3 35.44 15.05Z"
        fill="white"
      />
    </Svg>
  );
}
